import React from 'react';
import './../../styles/Buttons/DownloadButton.css';

const DownloadButton = ({ className, link, title }) => {
  const handleDownload = () => {
    if (!link) {
      console.error("Download link is not provided.");
      return;
    }

    const fileName = link.split('/').pop();
    const linkElement = document.createElement('a');
    linkElement.href = link;
    linkElement.setAttribute('download', fileName);
    document.body.appendChild(linkElement);
    linkElement.click();
    document.body.removeChild(linkElement);
  };

  return (
    <button onClick={handleDownload} className={className ? className : "download-button"}>
      {title}
    </button>
  );
};

export default DownloadButton;
